<script>
import utils from '@/utils/common';
import TaskViewParametersPopup from './TaskViewParametersPopup.vue';

export default {
  name: 'TaskViewPriorityDispatcher',
  components: { TaskViewParametersPopup },
  props: {
    action: String,
    tasks: Array,
    isOpened: Boolean,
  },
  computed: {
    changedTasksWord() {
      return utils.pluralWord(this.tasks.length, 'задаче', 'задачах', 'задачах');
    },

    options() {
      return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    },
  },
  methods: {
    async submit(value) {
      const question = `Вы действительно хотите установить новый приоритет в ${this.changedTasksWord}?`;
      const text = 'Приоритет установлен';

      if (await this.$confirm(question)) {
        this.$emit('submit', { result: { [this.action]: +value }, onSuccess: () => { this.$push({ text }); } });
      }
    },
  },
};
</script>

<template lang="pug">
TaskViewParametersPopup(v-if="isOpened" :options="options" header="Установить приоритет" label="Выберите приоритет" @submit="submit" @close="$emit('close')")
</template>

<style scoped lang="scss">

</style>
